import { RentalAdvert, SaleAdvert, RentalAdvertTranslation, SaleAdvertTranslation } from "../../../types/types";
import * as React from "react"
import ReadMore from "./ReadMore";

type Props = {
  advert: RentalAdvert | SaleAdvert
  translation: RentalAdvertTranslation | SaleAdvertTranslation
}

export default (props: Props) : JSX.Element => (
  props.advert.nearSkiing && props.advert.skiArea && props.advert.skiDistanceTranslation ?
    <>
      <div className="content-part">
        <h3>
          {I18n.t("rental_adverts.headers.skiing")}
        </h3>
        <div>
          <strong>
            {I18n.t('adverts.ski_area.name')}:
          </strong>
          {' '}{props.advert.skiArea.name}
        </div>
        {
          props.advert.skiDistanceTranslation ?
            <div>
              <strong>
                {I18n.t('adverts.ski_area.distance')}:
              </strong>
              {' '}{props.advert.skiDistanceTranslation}
            </div>
          : ''
        }
        <div className="description">
          {!!props.translation && props.translation.skiDistanceText ?
            <ReadMore height={180}>
              <div>
                {props.translation.skiDistanceText}
              </div>
            </ReadMore>
          : <></>}
        </div>
      </div>
      <hr />
    </>
  : <></>
)
